import * as React from "react";
import { connect } from "react-redux";
import navigationService from "src/dataServices/NavigationService";
import { IApplicationState } from "src/state";
import { INonprofitMiniProfile } from "src/state/nonprofit";
import NavigationMenu from "./NavigationMenu";

interface IPropsFromState {
  nonprofit: INonprofitMiniProfile;
  currentPath: string;
}

export type INavigationProps = IPropsFromState;

export class Navigation extends React.PureComponent<INavigationProps> {
  public render() {
    const { nonprofit, currentPath } = this.props;
    const navigationLinks = navigationService.getNavigationLinks(nonprofit);
    return navigationLinks && navigationLinks.length > 0 ? (
      <NavigationMenu key={navigationLinks.length} initialItems={navigationLinks} currentPath={currentPath} />
    ) : null;
  }
}

const mapStateToProps = ({ nonprofit }: IApplicationState) => ({
  nonprofit: nonprofit.miniProfile,
  currentPath: window.location.pathname
});

export default connect(mapStateToProps)(Navigation);
